import { App, ConfigProvider } from "antd";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import AntAppFeedbackConnected from "./AntAppFeedback.tsx";
import { store } from "./store.ts";
import "./files/zip-export/store.tsx";
import "./fonts.css";
import ConnectedLandingPage from "./LandingPage.tsx";
import "./reset.css";
import "flag-icons/css/flag-icons.min.css";
import { globalTheme } from "./theme.ts";

const root = document.getElementById("root");

if (root) {
  createRoot(root).render(
    <ConfigProvider theme={globalTheme}>
      <Provider store={store}>
        <StrictMode>
          <App>
            <ConnectedLandingPage />
            <AntAppFeedbackConnected />
          </App>
        </StrictMode>
      </Provider>
    </ConfigProvider>
  );
}
